export const KeyCodes = {
  escape: 27,
  tab: 9,
  enter: 13,
  arrowUp: 38,
  arrowDown: 40,
};
